import React, {useCallback, useState} from "react";
import "./index.scss";
import Footer from "features/layouts/footer";
import HelpButton from "features/components/help-button";
import {array, bool, oneOf, string} from "prop-types";
import logoWhite from "images/logo/white.svg";
import ProfileDropdown from "features/layouts/pages/logged-in/profile-dropdown";
import {historyObject} from "historyObject";
import {Breadcrumbs} from "features/components/breadcrumbs";
import Title from "features/components/title";
import {__} from "services/i18n";
import {MOBILE_MEDIA_QUERY_THRESHOLD, SHOW_MESSENGER_FAB} from "constants.js";
import {Icon} from "features/components/icon";
import {useMediaQuery} from "services/utils/utils";
import {SearchModalPortal} from "features/modals/search";
import NotificationButton from "features/components/notification-button";
import Button from "features/components/button";
import {TutorialModal} from "features/modals/onboarding/tutorial";


export const LoggedInLayout = (props) => {
    const {className, type, breadcrumbs, showTutorialButton = false} = props;
    const isMobile = useMediaQuery(MOBILE_MEDIA_QUERY_THRESHOLD);
    const navigateTo = useCallback((link) => {
        historyObject.push(link)
    }, []);

    const buildMenu = useCallback(() => {
        const menuItems = [
            {
                title: "menu.for-you",
                link: "/home"
            },
            {
                title: "menu.videos",
                link: "/videos"
            },
            {
                title: "menu.events",
                link: "/events"
            },
            {
                title: "menu.threads",
                link: "/threads"
            },
            {
                title: "menu.people",
                link: "/people"
            }
        ];
        return <div className="menu-list">
            {
                menuItems.map(i => <div onClick={() => navigateTo(i.link)} key={i.title} className={`item ${window.location.hash === `#${i.link}` ? "active" : ""}`}>
                    <Title size={14}>{__(i.title)}</Title>
                </div>)
            }
        </div>
    }, [navigateTo]);

    const [mobileOpen, setMobileOpen] = useState(false);
    const [showTutorial, setTutorial] = useState(false);

    const buildMobileMenu = useCallback(() => {
        return <div className={`mobile-menu ${mobileOpen ? "open" : ""}`}>
            {buildMenu()}
            <ProfileDropdown/>
        </div>
    }, [buildMenu, mobileOpen]);

    const toggleMobileMenu = useCallback(() => {
        setMobileOpen(!mobileOpen);
    }, [setMobileOpen, mobileOpen]);


    const [showSearchModal, setShowSearchModal] = useState(false);
    const toggleSearchModal = useCallback(() => {
        setShowSearchModal(!showSearchModal);
    }, [showSearchModal]);

    return <div className={`layout-logged-in ${className || ""} ${type || "dark"}`}>
        <div className={`header ${mobileOpen ? "mobile-open" : ""}`}>
            <div className="header-wrapper">
                <div className="menu">
                    <img onClick={() => historyObject.push("/")} className={"logo"} src={logoWhite} alt={"Osa logo"} />
                    {!isMobile && buildMenu()}
                </div>
                <div className="profile-notification">
                    {!isMobile ? <ProfileDropdown/> : <div className="hamburger" onClick={toggleMobileMenu}><Icon>{mobileOpen ? "close" : "menu"}</Icon></div>}
                    <NotificationButton />
                    <div className={"search-box"} onClick={toggleSearchModal}>
                        <Icon>search</Icon>
                        <Title size={14}>{__("common.search")}</Title>
                    </div>
                </div>
            </div>
        </div>
        {isMobile && buildMobileMenu()}
        {(breadcrumbs || []).length > 0 && <div className="breadcrumbs-bg">
            <Breadcrumbs type={"dark"} items={breadcrumbs} showHomeIcon={true}/>
            {showTutorialButton && <div className="tutorial-button">
                <Button title={__("buttons.tutorial")} type={"clear"} onClick={() => setTutorial(true)}
                        icon={"comment-video"}/>
            </div>}
            {/*istanbul ignore next*/showTutorial && <TutorialModal onHide={() => setTutorial(false)} />}
        </div>}
        <div className="page-wrapper">
            {props.children}
        </div>
        <Footer type={type || "dark"} />
        {/* istanbul ignore next */ SHOW_MESSENGER_FAB && <HelpButton/>}
        {showSearchModal && <SearchModalPortal onClose={toggleSearchModal} />}
    </div>
};

LoggedInLayout.propTypes = {
    className: string,
    type: oneOf(["dark", "light"]),
    breadcrumbs: array,
    showTutorialButton: bool
}